<template>
  <div>
    <nav v-if="!$store.state.isQCAS" class="navbar navbar-transparent navbar-absolute navbar-login">
      <div class="container" style="width: auto">
        <div class="navbar-header">
          <a href="https://www.qualificationcheck.com" target="_blank">
            <img style="height: 70px; padding: 5px" src="static/img/qc/QC-Logo-2.png" alt="QualificationCheck"/>
          </a>
        </div>
        <div v-if="$store.state.partnerLogo" class="navbar-header pull-right">
          <img style="height: 70px; padding-right: 27px" :src="$store.state.partnerLogo" />
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page" style="min-height: 0px; height: auto" v-loading="loadingSubdomain" element-loading-spinner="qc-spinner">
      <div class="full-page full-page-background login-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content" :class="{'no-banner-content': $store.state.isQCAS}">
          <div class="container">
            <transition name="el-fade-in-linear" mode="out-in">
              <router-view :atid="atid" :referralcode="referralcode" :e="e" :r="r"></router-view>
            </transition>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>  
  import LogRocket from 'logrocket'
  import {version} from '../../../package.json';

  export default { 
    data() {
      return {
        atid: null,
        iaoi: null,
        referralcode: null,
        e: null,
        r: null,
        loadingSubdomain: false,
      }
    },
    created () {
      this.iaoi = this.$route.query.iaoi
      this.referralcode = this.$route.query.ref
      this.e = this.$route.query.e ? decodeURIComponent(this.$route.query.e) : null
      this.r = this.$route.query.r
      var location = window.location.href
      if(location.includes('debug.qualificationcheck')) {
        console.log('initting logrocket with ' + 'qc-debug/qc-debug')
        LogRocket.init('qc-debug/qc-debug', {
          release: version
        })
        this.$snotify.warning("QC Debug Mode enabled. Application version v" + version + ". Please notify QC support when you are finished so we can review your session.", 
          "Warning", {
          timeout: 10000
        })
      } else if (location.includes('app.qualificationcheck') 
              || location.includes('beta.qualificationcheck')
              || location.includes('preprod.qualificationcheck') 
              || location.includes('sandbox.qualificationcheck') 
              || location.includes('localhost')) {
        if(this.iaoi == 'QC-ImpColLon' || this.iaoi == 'I50ImpColLon' || this.iaoi == 'MARS'|| this.iaoi == 'UOE' || this.iaoi == 'QC-') {
          this.atid = '1'
        } else if(this.iaoi == 'QC-ETS' || this.iaoi == 'SRA') {
          this.atid = '2'
        } else if(this.iaoi == 'QC-STGP' || this.iaoi == 'L41UniofLiv') {
          this.atid = '3'
        } else if(this.iaoi == 'QC-HOGW' || this.iaoi == 'QC-UNIGIB') {
          this.atid = '4'
        } else if(this.iaoi) {
          this.atid = '0'
        } else {
          this.atid = this.$route.query.atid
        }
      } else if(window.location.href.includes('trac.qualificationcheck')) {
        this.referralcode = 'trac'
      } else if(window.location.href.includes('gbg.qualificationcheck')) {
        this.referralcode = 'gbg'
      } else {
        this.loadingSubdomain = true;
        var host = window.location.host
        var subdomain = host.split('.')[0]
        this.$api.getApplicationTemplateOwner(subdomain)
        .then((response) => {
          this.atid = "" + response.data.id;
          this.loadingSubdomain = false;
        })
        .catch((error) => {
          this.atid = "-1"
          this.loadingSubdomain = false;
        });
      }
    },
    mounted () {
      if(this.$route.query.qcmc) {
        this.$store.commit('setQCMC', this.$route.query.qcmc)
      }
    }
  }
</script>

<style>
</style>
